export default __webpack_public_path__ + "static/media/Nice-Battlefield-4.17f8af90.jpg";